const newContainer = () => import("@/layouts/Default.vue");
const routerParent = () => import("@/layouts/routerParrent.vue");
const mySurveyList = () => import("../views/my-survey/my-survey-list.vue");
const addSurvey = () => import("../views/add-survey/add-survey.vue");
const surveyGroupList = () =>
  import("../views/survey-group/survey-group-list.vue");
const editSurveyGroup = () =>
  import("../views/survey-group/survey-group-edit/editSurveyGroup.vue");

export const surveyRoutes: any[] = [
  {
    path: "/survey",
    name: "survey-parent",
    redirect: "/survey/add",
    meta: {
      label: "خانه",
      requiresAuth: true,
      moduleName: "survey",
    },
    component: newContainer,
    children: [
      {
        path: "add",
        name: "survey",
        component: addSurvey,
        meta: {
          label: "ایجاد نظر",
          requiresAuth: true,
          redesigned: true,
        },
      },
      {
        path: "survey-group",
        name: "survey_group",
        meta: {
          label: "گروه نظردهی",
          requiresAuth: true,
          redesigned: true,
        },
        redirect: "/survey/survey-group/list",
        component: routerParent,
        children: [
          {
            path: "list",
            name: "survey-group-list",
            component: surveyGroupList,
            meta: {
              label: "لیست گروه نظردهی",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: "edit/:code",
            name: "survey_group_edit",
            component: editSurveyGroup,
            meta: {
              label: "ویرایش گروه نظردهی",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: "parvandeh/limit/:code/:id/:termId",
            name: "survey_parvandeh_limit",
            // component: surveyParvandehLimit,
            meta: {
              label: "اعمال محدودیت در پرونده‌های قابل مشاهده",
              requiresAuth: true,
            },
          },
        ],
      },
      {
        path: "all-survey",
        name: "all_survey",
        meta: {
          label: "نظرات",
          requiresAuth: true,
        },
        redirect: "/survey/all-survey/search",
        // component: routerParent,
        children: [
          {
            path: "search",
            name: "all_survey_search",
            meta: {
              label: "لیست نظرات",
              requiresAuth: true,
            },
            // component: allSurveySearch,
          },
          {
            path: "view/:code",
            name: "view_survey",
            // component: editSurvey,
            meta: {
              label: "مشاهده نظر",
              requiresAuth: true,
            },
          },
        ],
      },
      {
        path: "my-survey",
        name: "my_survey",
        meta: {
          label: "نظرات",
          requiresAuth: true,
          redesigned: true,
        },
        redirect: "/survey/my-survey/list",
        component: routerParent,
        children: [
          {
            path: "list",
            name: "my-survey-list",
            component: mySurveyList,
            meta: {
              label: "لیست نظرات من",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: "edit/:code",
            name: "edit_survey",
            // component: editSurvey,
            meta: {
              label: "ویرایش نظر",
              requiresAuth: true,
            },
          },
        ],
      },
      {
        path: "survey-base",
        name: "survey_base",
        meta: {
          label: "نظردهی",
          requiresAuth: true,
        },
        redirect: "/survey/survey-base/search",
        // component: routerParent,
        children: [
          {
            path: "search",
            name: "survey_base_search",
            // component: surveyBaseSearch,
            meta: {
              label: "لیست نظردهی بانوان تاثیرگذار",
              requiresAuth: true,
            },
          },
        ],
      },
      {
        path: "women-influence-confirm",
        name: "survey_women_influence_confirm",
        meta: {
          label: "نظردهی",
          requiresAuth: true,
        },
        redirect: "/survey/women-influence-confirm/list",
        // component: routerParent,
        children: [
          {
            path: "list",
            name: "survey-women-influence-confirm-list",
            // component: womenInfluenceConfirm,
            meta: {
              label: "انتخاب بانوان تاثیرگذار",
              requiresAuth: true,
            },
          },
        ],
      },
    ],
  },
];
